import React from 'react';
import { createPortal } from 'react-dom';
import { CustomDialogProps } from './types';
import { useCustomDialog } from './useCustomDialog';
import styles from './CustomDialog.module.css';

/**
 * モダンでおしゃれなカスタムダイアログコンポーネント
 */
export const CustomDialog: React.FC<CustomDialogProps> = (props) => {
  const {
    isOpen,
    title,
    message,
    confirmText = '確認',
    cancelText = 'キャンセル',
    onConfirm,
    onCancel,
    type = 'info'
  } = props;

  const { dialogRef, stopPropagation, getIcon, getColor } = useCustomDialog(props);

  if (!isOpen) return null;

  // createPortalを使用してダイアログをdocument.bodyに直接レンダリング
  return createPortal(
    <div 
      className={styles['custom-dialog-overlay']} 
      onClick={onCancel} // オーバーレイクリックでキャンセル
      data-testid="custom-dialog-overlay"
    >
      <div 
        className={styles['custom-dialog-container']} 
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="dialog-title"
        onClick={stopPropagation} // ダイアログコンテナでクリックを止める
        data-testid="custom-dialog-container"
      >
        <div 
          className={styles['custom-dialog-header']} 
          style={{ borderBottom: `3px solid ${getColor()}` }}
        >
          <span className={styles['custom-dialog-icon']}>{getIcon()}</span>
          <h2 
            id="dialog-title" 
            className={styles['custom-dialog-title']}
            data-testid="custom-dialog-title"
          >
            {title}
          </h2>
        </div>
        
        <div className={styles['custom-dialog-content']}>
          <p 
            className={styles['custom-dialog-message']}
            data-testid="custom-dialog-message"
          >
            {message}
          </p>
        </div>
        
        <div className={styles['custom-dialog-actions']}>
          <button 
            className={`${styles['custom-dialog-button']} ${styles['custom-dialog-cancel-button']}`}
            onClick={(e) => {
              stopPropagation(e);
              onCancel();
            }}
            type="button"
            data-testid="custom-dialog-cancel-button"
          >
            {cancelText}
          </button>
          <button 
            className={`${styles['custom-dialog-button']} ${styles['custom-dialog-confirm-button']}`}
            style={{ backgroundColor: getColor() }}
            onClick={(e) => {
              stopPropagation(e);
              onConfirm();
            }}
            type="button"
            data-testid="custom-dialog-confirm-button"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body // document.bodyにレンダリング
  );
}; 